/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'

/**
 * Мета-данные организации пользователя
 * @export
 * @interface UserMeta
 */
export interface UserMeta {
  /**
   * UUID записи мета-данных
   * @type {string}
   * @memberof UserMeta
   */
  uuid?: string | null
  /**
   * Тип организации (frontend-имя типа)
   * @type {OrganizationType}
   * @memberof UserMeta
   */
  organizationType?: OrganizationType | null
  /**
   * Данные организации (inn, name, fullName, address, passport, snils — набор зависит от типа; внутрь дублируется ключ organizationType)
   * @type {{ [key: string]: any; }}
   * @memberof UserMeta
   */
  organizationData?: { [key: string]: any } | null
}

/**
 * Check if a given object implements the UserMeta interface.
 */
export function instanceOfUserMeta(value: object): value is UserMeta {
  return true
}

export function UserMetaFromJSON(json: any): UserMeta {
  return UserMetaFromJSONTyped(json, false)
}

export function UserMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserMeta {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'] == null ? undefined : json['uuid'],
    organizationType:
      json['organizationType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['organizationType']),
    organizationData:
      json['organizationData'] == null ? undefined : json['organizationData'],
  }
}

export function UserMetaToJSON(value?: UserMeta | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    organizationType: OrganizationTypeToJSON(value['organizationType']),
    organizationData: value['organizationData'],
  }
}
